/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  Col, Icon, Layout, Popover, Row
} from 'antd';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import App from 'routes/index';
import { fetchReset, fetchStart } from 'src/appRedux/actions/Common';
import { AuthenticationMenu, listVaiTro, vaiTros as VaiTro } from 'src/helpers/Authorization';
import Permission from 'src/helpers/Permission';
import { apiSaveReduxLocal } from 'src/util/commonAPI';
import { footerText } from 'util/config';
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from '../../constants/ThemeSetting';
import Sidebar from '../Sidebar/index';
import AboveHeader from '../Topbar/AboveHeader/index';
import BelowHeader from '../Topbar/BelowHeader/index';
import HorizontalDark from '../Topbar/HorizontalDark/index';
import HorizontalDefault from '../Topbar/HorizontalDefault/index';
import Topbar from '../Topbar/index';
import InsideHeader from '../Topbar/InsideHeader/index';
import NoHeaderNotification from '../Topbar/NoHeaderNotification/index';

const { Content, Footer } = Layout;

class MainApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vaiTroAvailble: false,
      activedVaiTro: {}
    };
    this.mounted = false;
  }

  async componentDidMount() {
    this.mounted = true;
    const { authUser, vaiTro } = this.props;
    const authInfo = { authUser, vaiTro };
    const { vaiTroAvailble } = this.state;
    // Khi login thành công sẽ gọi api dùng chung trước
    await this.handleInitState();
    if (!isEmpty(authUser) && !isEmpty(vaiTro.content) && !vaiTroAvailble) {
      const activedVaiTro = await this.xuLyVaiTro(authInfo);
      await this.setStateData({ vaiTroAvailble: true, activedVaiTro });
    }
  }

  async componentDidUpdate() {
    const { authUser, vaiTro } = this.props;
    const authInfo = { authUser, vaiTro };
    const { vaiTroAvailble } = this.state;
    if (!isEmpty(authUser) && !isEmpty(vaiTro.content) && !vaiTroAvailble) {
      const activedVaiTro = await this.xuLyVaiTro(authInfo);
      await this.setStateData({ vaiTroAvailble: true, activedVaiTro });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /**
   * Set state properties
   * @param {object} state data cần setState
   * @param {function} callback thực thi hàm sau khi đã cập nhật state hoàn tất
   * @returns {void} gọi hàm this.setStateData để cập nhật state
   * @memberof MainApp
   */
  setStateData = (state, callback) => {
    if (!this.mounted) {
      return;
    }
    this.setState(state, callback);
  }

  /**
   * handleInitState: Gọi api dùng chung lưu localstore, reducers khi login thành công
   * @memberof MainApp
   */
  handleInitState = () => {
    const { apiCall } = this.props;
    apiSaveReduxLocal.getListHuyen(apiCall, 'dsHuyen');
  }

  getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-container-wrap';
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-container-wrap';
      default:
        return '';
    }
  };

  getNavStyles = (navStyle, userInfo, activedVaiTro) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar activedVaiTro={activedVaiTro} userInfo={userInfo} />;
      case NAV_STYLE_DRAWER:
        return <Topbar activedVaiTro={activedVaiTro} userInfo={userInfo} />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar activedVaiTro={activedVaiTro} userInfo={userInfo} />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  getSidebar = (navStyle, width, activedVaiTro) => {
    if (width < TAB_SIZE) {
      return <Sidebar activedVaiTro={activedVaiTro} />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_DRAWER:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar activedVaiTro={activedVaiTro} />;
      default:
        return null;
    }
  };

  /**
  * xuLyVaiTro: Xử lý vai trò sẽ được sử dụng trong ứng dụng
  * @param {object} values
  * @memberof MainApp
  */
  xuLyVaiTro = async (values) => {
    const vaiTro = await listVaiTro(values.authUser);
    const activedVaiTro = await VaiTro(values.vaiTro.content, vaiTro);
    return activedVaiTro;
  }

  /**
   * onClickMenu: Xử lý kích menu
   * @param {string} values
   * @memberof MainApp
   */
  onClickMenu = (values) => {
    const { history } = this.props;
    if (values === 'HO_TRO') {
      history.push('/ho-tro');
    }
  }

  render() {
    const {
      match, width, navStyle, authUser
    } = this.props;
    const { activedVaiTro } = this.state;
    const heThong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.HE_THONG]);
    const bieuMauChiTieu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.HE_THONG]);
    const heThongMenuOptions = (
      <div className="menu-setting">
        {heThong && <p><Link to="/he-thong/quyen"><Icon type="hdd" /> Quyền</Link></p>}
        {heThong && <p><Link to="/he-thong/phong-ban"><Icon type="team" /> Phòng ban</Link></p>}
        {heThong && <p><Link to="/he-thong/chuc-vu"><Icon type="exception" /> Chức vụ</Link></p>}
        {heThong && <p><Link to="/he-thong/vai-tro"><Icon type="solution" /> Vai trò</Link></p>}
        {heThong && <p><Link to="/he-thong/nguoi-dung"><Icon type="user" /> Người dùng</Link></p>}
      </div>
    );
    const chiTieuMenuOptions = (
      <div className="menu-setting">
        {bieuMauChiTieu
          && <p><Link to="/quan-ly-bieu-mau/bieu-mau"><Icon type="hdd" /> Biểu mẫu</Link></p>}
        {bieuMauChiTieu
          && <p><Link to="/quan-ly-chi-tieu/chi-tieu"><Icon type="team" /> Chỉ tiêu</Link></p>}
      </div>
    );
    // const userInfo = getCookieValue('userInfo');
    return (
      <Layout className="gx-app-layout">
        {this.getSidebar(navStyle, width, activedVaiTro)}
        <Layout>
          {this.getNavStyles(navStyle, authUser, activedVaiTro)}
          <Content className={`gx-layout-content ${this.getContainerClass(navStyle)}`}>
            <App activedVaiTro={activedVaiTro} match={match} />
            <Footer>
              <div className="gx-layout-footer-content">
                <Row>
                  <Col md={4} xs={12}>{footerText}</Col>
                  <Col md={20} xs={12}>
                    <ul className="text-right mb0 mx0">
                      <li
                        className="d-inline-block px10 pointer"
                        onClick={() => this.onClickMenu('HO_TRO')}
                      >
                        <div>
                          <span title="Hỗ trợ"><Icon type="question-circle" /> HỖ TRỢ</span>
                        </div>
                      </li>
                      {bieuMauChiTieu
                        && (
                          <li className="d-inline-block px10 pointer">
                            <div>
                              <Popover content={chiTieuMenuOptions} placement="bottomRight" trigger="click">
                                <span title="Biểu mẫu - Chỉ tiêu"><Icon type="file-text" /> BIỂU MẪU - CHỈ TIÊU</span>
                              </Popover>
                            </div>
                          </li>
                        )}
                      {heThong && (
                        <li className="d-inline-block px10 pointer">
                          <div>
                            <Popover content={heThongMenuOptions} placement="bottomRight" trigger="click">
                              <span title="Hệ thống"><i className="icon icon-setting fa-lg" /></span>
                            </Popover>
                          </div>
                        </li>
                      )}
                    </ul>
                  </Col>
                </Row>
              </div>
            </Footer>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

MainApp.propTypes = {
  authUser: PropTypes.objectOf(PropTypes.any).isRequired,
  vaiTro: PropTypes.any.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  width: PropTypes.number.isRequired,
  navStyle: PropTypes.string.isRequired,
  apiCall: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings, auth }) => {
  const { width, navStyle } = settings;
  const { authUser, vaiTro } = auth;
  return {
    width, navStyle, authUser, vaiTro
  };
};
const mapDispatchToProps = (dispatch) => ({
  apiCall: (configAPI, getName, cbSuccess, cbError) => {
    dispatch(fetchStart(configAPI, getName, cbSuccess, cbError));
  },
  onFetchReset: (getName) => {
    dispatch(fetchReset(getName));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(MainApp);
